(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pessoa-colour-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pessoa-colour-swatches')) {
    customElements.define('pessoa-colour-swatches', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const position = (event) => {
          const item = event.target.closest('.pessoa-colours__item');
          if (!item || !this.contains(item)) return;
          const tip = item.querySelector('.pessoa-colours__tooltip');
          if (!tip) return;
          tip.style.setProperty('--pc-tooltip-shift', '0px');
          const rect = tip.getBoundingClientRect();
          const shift = rect.left < 12 ? 12 - rect.left : Math.min(0, document.documentElement.clientWidth - 12 - rect.right);
          tip.style.setProperty('--pc-tooltip-shift', `${shift}px`);
        };
        const reset = (event) => {
          const item = event.target.closest('.pessoa-colours__item');
          if (item && !item.contains(event.relatedTarget)) item.removeAttribute('data-tooltip-dismissed');
        };
        this.addEventListener('pointerover', position, options);
        this.addEventListener('focusin', position, options);
        this.addEventListener('pointerout', reset, options);
        this.addEventListener('focusout', reset, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.querySelectorAll('.pessoa-colours__item').forEach(item => item.setAttribute('data-tooltip-dismissed', ''));
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
